import PagePage from './PagePage';

export default PagePage;



// WEBPACK FOOTER //
// ./src/components/PagePage/index.js